import corner3 from 'assets/img/illustrations/corner-3.png';
import React, { useContext, useEffect, useState } from 'react';
import {
  Button,
  Card,
  Col,
  Form,
  FormLabel,
  InputGroup,
  Modal,
  Offcanvas,
  Row,
  Spinner,
  Table
} from 'react-bootstrap';
import FalconComponentCard from 'components/common/FalconComponentCard';
import Flex from 'components/common/Flex';
import Pagination from 'components/common/Pagination';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SimpleBarReact from 'simplebar-react';
import {
  faLayerGroup,
  faPlusCircle,
  faStar,
  faTrash,
  faTrashAlt,
  faEdit,
  faEye,
  faUserTie
} from '@fortawesome/free-solid-svg-icons';
import { faStar as faStarRegular } from '@fortawesome/free-regular-svg-icons';
import api from 'util/api';
import logger from 'util/logger';
import _ from 'lodash';
import draftEntryUiHelper from 'helpers/draft-entry-ui-helper';
import { showAlert, showMasterSignerDialog } from 'stores/modal';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { AuthWizardContext } from 'context/Context';
import {
  actionAddIdentification,
  actionLogSigningAction,
  actionMapSignerToAllDocs,
  actionRemoveIdentification,
  actionRemoveSigner,
  actionReset
} from 'stores/signing';
import filters from 'util/filters';
import segmentHelper from 'helpers/segment-helper';
import idGenerator from 'util/idGenerator';
import enums from 'util/enums';
import classNames from 'classnames';
import Avatar from 'components/common/Avatar';
import IdentificationView from 'components/pages/notary/signing/steps/comp/IdentificationView';
import NotarySignerForm from 'components/pages/notary/signing/steps/s2/NotarySignerForm';
import { useListMasterSignersQuery } from 'rtk/signer.slice';
import FalconCardHeader from 'components/common/FalconCardHeader';
import IdentificationForm from 'components/pages/notary/signing/steps/s2/IdentificationForm';
import GenericAddressForm from 'components/pages/notary/signing/steps/comp/GenericAddressForm';
import MergedRecord from './MergedRecord';
import { useAsyncDebounce } from 'react-table';
import IconAlert from 'components/common/IconAlert';
import DuplicateRecord from './DuplicateRecord';
import utils from 'util/utils';
import moment from 'moment';
import './MasterClient.scss';

const MasterSigner = () => {
  // Listing is now driven by RTK Query (see useListMasterSignersQuery below).
  // Render list directly from RTK Query response (no local mirror state).
  const [show, setShow] = useState(true);
  const [sortBy, setSortBy] = useState('Created');
  const [isAsc, setIsAsc] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [pageSize, setPageSize] = useState(25);
  const [pageIndex, setPageIndex] = useState(0);
  const skip = pageIndex * pageSize;

  const {
    data: signerRes,
    isFetching,
    isLoading,
    isError: signerLoadError,
    error: signerError,
    refetch: refetchMasterSigners
  } = useListMasterSignersQuery({
    skip,
    pageSize,
    keyword: searchKeyword,
    sortKey: sortBy,
    sortOrderAsc: isAsc
  });
  const loading = isFetching || isLoading;

  const signerObjects = signerRes?.Objects || [];
  const signerTotalRecords = signerRes?.TotalRecords ?? 0;
  const signerEndOfResults = !!signerRes?.EndOfResults;
  const totalRecords = signerTotalRecords;
  const endOfResults = signerEndOfResults;
  const dispatch = useDispatch();
  const [toggleFavorite, setToggleFavorite] = useState(false);
  const [SelectedIdentification, setSelectedIdentification] = useState({});
  const [isSignerChanged, setIsSignerChanged] = useState(false);

  const signerInit = {
    isSaving: false,
    isEditMode: false,
    validationErr: [],
    witnessChoice: enums.UI_FLOW_TYPE.SIGNER,
    sorted_witness_ids: null,
    signer_id: null,
    Prefix: '',
    FirstName: '',
    MiddleName: '',
    LastName: '',
    Suffix: '',
    signer_suffix: '',
    Identifications: [],
    witnessIdentifications: [],
    witnessNameLocationResults: [],
    witnessSignatureResults: [],
    IsFavorite: false,
    signer_first_name: '',
    signer_middle_name: '',
    signer_last_name: ''
  };

  const { user } = useContext(AuthWizardContext);
  const [collapsed, setCollapsed] = useState(false);
  const [isDocumentWitness, setIsDocumentWitness] = useState(false);
  const [showIdentityForm, setShowIdentityForm] = useState(false);
  const [showAddressForm, setShowAddressForm] = useState(false);
  const [identityItem, setIdentityItem] = useState();
  const [addressValue, setAddressValue] = useState();
  const [witnessId, setWitnessId] = useState(null);
  const [signerData, setSignerData] = useState(signerInit);
  const [isSaveIdentityToRedux, setSaveIdentityToRedux] = useState(false);
  const [identityForUser, setIdentityForUser] = useState(null);
  const { signers, witnesses, identifications, signatures, location } =
    useSelector(state => state.signing);
  const [selectedRecords, setSelectedRecords] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedDuplicateRecords, setSelectedDuplicateRecords] = useState([]);
  const [showDuplicateModal, setShowDuplicateModal] = useState(false);
  const [issignerDelete, setIsSignerDelete] = useState(false);
  const [selectedDeletingSigner, setSelectedDeletingSigner] = useState(null);
  useEffect(() => {
    // setPreviousAddress(location);
  }, [location]);

  const removeSigner = signer_id => {
    let foundSigner = _.find(signers, s => s.signer_id === signer_id);
    dispatch(
      actionLogSigningAction(
        `Signer ${filters.formatNameObj(foundSigner)} removed.`
      )
    );
    dispatch(actionRemoveSigner(signer_id));
    segmentHelper.track(segmentHelper.events.SIGNING_REMOVE_SIGNER_CLICK);
  };
  const removeSignerIdentificationFromRedux = identification_id => {
    dispatch(actionRemoveIdentification({ identification_id }));
    segmentHelper.track(segmentHelper.events.SIGNING_REMOVED_IDENTIFICATION);
  };
  const openSignerForm = signer_id => {
    if (signer_id === null) {
      setSignerData(signerData => ({
        ...signerData,
        signer_id: idGenerator.getSignerId(),
        sorted_witness_ids: [],
        isEditMode: false,
        FirstName: '',
        MiddleName: '',
        LastName: '',
        Prefix: '',
        Suffix: '',
        witnessChoice: enums.UI_FLOW_TYPE.SIGNER,
        validationErr: []
      }));
    } else {
      let signer = _.find(signers, s => {
        return s.signer_id === signer_id;
      });
      if (signer) {
        setSignerData(_.extend(signerInit, signer));
      }
    }
    setCollapsed(true);
  };

  const openDocumentWithness = () => {
    setSignerData(signerData => ({
      ...signerData,
      signer_id: idGenerator.getSignerId(),
      sorted_witness_ids: [],
      isEditMode: false,
      signer_first_name: '',
      signer_middle_name: '',
      signer_last_name: '',
      signer_prefix: '',
      signer_suffix: '',
      witnessChoice: enums.UI_FLOW_TYPE.SIGNER,
      validationErr: []
    }));
    setCollapsed(true);
    setIsDocumentWitness(true);
  };

  const resetSignerState = () => {
    setSignerData(signerInit);
  };

  //This useEffect will store Identification in localState we will push to Redux on Client Save
  useEffect(() => {
    if (identityItem) {
      //logger.log('Received Identity', identityItem);
      if (identityItem.witness_id) {
        let witnessIdentificationUpdate = _.concat(
          [],
          signerData.witnessIdentifications || []
        );
        _.remove(
          witnessIdentificationUpdate,
          wid => wid.witness_id === identityItem.witness_id
        );
        witnessIdentificationUpdate.push({
          signer_id: identityForUser,
          witness_id: identityItem.witness_id,
          identification: identityItem
        });
        setSignerData(signerData => ({
          ...signerData,
          witnessIdentifications: witnessIdentificationUpdate
        }));
      } else {
        if (isSaveIdentityToRedux) {
          dispatch(
            actionAddIdentification({
              signer_id: identityForUser,
              identification_id: identityItem.identification_id,
              first_name: identityItem.id_first_name,
              middle_name: identityItem.id_middle_name,
              last_name: identityItem.id_last_name,
              id_first_name: identityItem.id_first_name,
              id_middle_name: identityItem.id_middle_name,
              id_last_name: identityItem.id_last_name,
              prefix: identityItem.id_prefix,
              suffix: identityItem.id_suffix,
              id_type: identityItem.id_type,
              id_type_other: identityItem.id_type_other,
              id_number: identityItem.id_number,
              id_issued_date: identityItem.id_issued_date,
              id_expiration_date: identityItem.id_expiration_date,
              date_of_birth: identityItem.date_of_birth,
              id_issuing_state: identityItem.id_issuing_state,
              id_address_1: identityItem.id_address_1,
              id_address_2: identityItem.id_address_2,
              id_city: identityItem.id_city,
              id_state: identityItem.id_state,
              id_postal_code: identityItem.id_postal_code,
              notes: identityItem.notes,
              scan_vendor: identityItem.scan_vendor,
              scan_data: identityItem.scan_data
            })
          );
          dispatch(actionMapSignerToAllDocs(identityForUser));
        } else {
          const findExistingIdentification =
            SelectedIdentification.identification_id
              ? signerData.signerIdentifications.findIndex(
                  item =>
                    item?.identification?.identification_id ==
                    SelectedIdentification.identification_id
                )
              : -1;
          let IdentificationsUpdate = signerData.signerIdentifications || [];
          if (
            findExistingIdentification == -1 &&
            !SelectedIdentification.identification_id
          ) {
            IdentificationsUpdate.push({
              signer_id: identityForUser,
              identification: identityItem
            });
            setSignerData(signerData => ({
              ...signerData,
              signerIdentifications: IdentificationsUpdate
            }));
          } else {
            let updateIdentityItem = signerData?.signerIdentifications?.map(
              (item, index) => {
                if (index === findExistingIdentification) {
                  return { identification: identityItem };
                }
                return item;
              }
            );
            setSignerData({
              ...signerData,
              signerIdentifications: updateIdentityItem
            });
          }
        }
      }
      setShowIdentityForm(false);
      setSelectedIdentification({});
    }
  }, [identityItem]);

  //This useEffect will store Address in localState we will push to Redux on Client Save
  useEffect(() => {
    //logger.log('Adding address on state', addressValue);
    if (addressValue) {
      let witnessNameLocationUpdate =
        signerData.witnessNameLocationResults || [];
      if (witnessNameLocationUpdate.length) {
        _.remove(
          witnessNameLocationUpdate,
          wid => wid.witness_id === witnessId
        );
      }
      witnessNameLocationUpdate.push({
        witness_id: witnessId,
        location: addressValue
      });

      setSignerData(signerData => ({
        ...signerData,
        witnessNameLocationResults: witnessNameLocationUpdate
      }));
      setShowAddressForm(false);
    }
    //logger.log('Updated signerdata after location', signerData);
  }, [addressValue]);

  const openSignerIdentityForm = (signer_id, saveToRedux) => {
    setSaveIdentityToRedux(saveToRedux);
    setIdentityForUser(signer_id);
    setWitnessId(null);
    setShowIdentityForm(true);
    segmentHelper.track(
      segmentHelper.events.MASTER_CLIENT_SIGNING_ADD_ANOTHER_IDENTIFICATION
    );
  };

  const openWitnessIdentityForm = (signer_id, witness_id) => {
    setIdentityForUser(signer_id);
    setWitnessId(witness_id);
    setShowIdentityForm(true);
  };

  const openWitnessAddressForm = witness_id => {
    setWitnessId(witness_id);
    setShowAddressForm(true);
    let witnessAddress = _.find(
      signerData.witnessNameLocationResults,
      w => w.witness_id === witness_id
    );
    // setAddressValue(witnessAddress.location)
  };

  const openIdentityViewModel = (title, identification) => {
    dispatch(
      showAlert(
        title,
        <div>
          <IdentificationView title={title} identification={identification} />
        </div>,
        res => {
          if (res) {
            //setStartSavingFavourite(startSavingFavourite + 1);
          }
        }
      )
    );
  };

  const WitnessRow = ({ signer, witness, index, isLast }) => {
    //logger.log('witness', witness);
    let witnessIdentification = _.find(
      identifications,
      w => w.witness_id === witness.witness_id
    );
    //logger.log('WitnessRow witnessIdentification', witnessIdentification);
    let witnessSignature = witness.signature;
    let witnessLocation = witness.location;
    let witnessDetail = witness.witness_name;
    return witness ? (
      <>
        <hr className="mb-1" />
        <Row
          className={classNames('align-items-center py-2', {
            'border-bottom border-200 ': !isLast
          })}
        >
          <Col className="py-1">
            <Flex className="align-items-center">
              <div className="avatar avatar-sm me-3">
                <div className={`avatar-name rounded-circle bg-soft-priamry`}>
                  <span className={`fs--2`}>
                    {index} (
                    {witnessDetail.first_name[0] + witnessDetail.last_name[0]})
                  </span>
                </div>
              </div>
              <Flex className="position-relative">
                <Flex tag="h6" align="left" className="mb-0">
                  <Avatar
                    size="m"
                    name={index + 1 + ''}
                    mediaClass={`text-primary bg-soft-primary fs--2 me-2`}
                  />
                  <div className="ms-2 fs-1">
                    <span className="text-primary">Witness </span>{' '}
                    <span className="text-800 stretched-link">
                      {witnessDetail.first_name + ' ' + witnessDetail.last_name}
                    </span>
                    <br />
                    <span className="fs--2 text-primary">
                      {' '}
                      {filters.getSignerTypeName(signer.identificationFlow)}
                    </span>
                  </div>
                </Flex>
              </Flex>
            </Flex>
          </Col>
          {/* <Col>
            <Row className="justify-content-end align-items-center">
              <Col xs="auto pe-0">
                <span
                  onClick={() =>
                    openIdentityViewModel(
                      `${witnessDetail.first_name}  ${witnessDetail.last_name}'s Identity`,
                      witnessIdentification
                    )
                  }
                >
                  {witnessIdentification?.length ? (
                    <Button variant="outline-primary" size="sm">
                      {witnessIdentification?.length}
                    </Button>
                  ) : (
                    'N/A'
                  )}
                </span>
              </Col>
            </Row>
          </Col> */}
        </Row>
        <Row>
          {witnessIdentification &&
            draftEntryUiHelper.getIdentificationViewCard(
              witnessIdentification,
              false
            )}

          {witnessSignature &&
            draftEntryUiHelper.getSignatureViewCards(
              'Witness Signature',
              witnessSignature.data
            )}

          {witnessLocation &&
            draftEntryUiHelper.getWitnessAddressViewCards(witnessLocation)}
        </Row>
      </>
    ) : (
      <></>
    );
  };

  const SignerRow = ({ data, isLast }) => {
    //logger.log('SignerRow data', data);
    let identification = _.filter(
      identifications,
      w => w.signer_id === data.signer_id
    );
    let isSigner = data.identificationFlow === enums.UI_FLOW_TYPE.SIGNER;
    let signature = _.filter(
      signatures,
      w => w.signer_id === data.signer_id && !w.witness_id
    );
    let witness = _.filter(witnesses, w => w.signer_id === data.signer_id);

    //logger.log('SignerRow Identification', identification);
    //logger.log('SignerRow signature', signature);
    //logger.log('SignerRow witness', witness);
    return data && data.first_name ? (
      <Card className="mt-3">
        <div className="p-3">
          <Row
            className={classNames('align-items-center py-2', {
              'border-bottom border-200 ': !isLast
            })}
          >
            <Col className="py-1">
              <Flex className="align-items-center">
                <div className="avatar avatar-xl me-3">
                  <div className={`avatar-name rounded-circle bg-soft-priamry`}>
                    <span className={`fs-0`}>
                      {data.first_name[0] + data.last_name[0]}
                    </span>
                  </div>
                </div>
                <Flex className="position-relative">
                  <Flex tag="h6" align="left" className="mb-0">
                    <div>
                      <span className="text-800 stretched-link">
                        {data.first_name + ' ' + data.last_name}
                      </span>
                      <br />
                      <span className="fs--2 text-primary">Client</span>
                    </div>
                  </Flex>
                </Flex>
              </Flex>
            </Col>
            <Col>
              <Row className="justify-content-end align-items-center">
                <Col xs="auto pe-0">
                  <span
                    onClick={() =>
                      openIdentityViewModel(
                        `${data.first_name}  ${data.last_name}'s Identification`,
                        identification
                      )
                    }
                  >
                    {identification?.length ? (
                      <Button variant="outline-primary" size="sm">
                        {identification?.length} Identification
                      </Button>
                    ) : (
                      'N/A'
                    )}
                  </span>
                </Col>
                <Col xs="auto">
                  {isSigner && (
                    <Button
                      variant="outline-primary"
                      className="mx-1"
                      onClick={() =>
                        openSignerIdentityForm(data.signer_id, true)
                      }
                    >
                      <FontAwesomeIcon icon={faPlusCircle} size="sm" />{' '}
                      Identification
                    </Button>
                  )}
                  <Button
                    variant="outline-danger"
                    className="mx-1"
                    onClick={() => removeSigner(data.signer_id)}
                  >
                    <FontAwesomeIcon icon={faTrash} size="sm" />{' '}
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            {isSigner ? (
              <>
                {identification &&
                  _.map(identification, i => {
                    return draftEntryUiHelper.getIdentificationViewCard(
                      i,
                      identification.length > 1
                        ? removeSignerIdentificationFromRedux
                        : false
                    );
                  })}

                {signature &&
                  _.map(signature, s => {
                    return draftEntryUiHelper.getSignatureViewCards(
                      'Signer Signature',
                      s.imgData.data
                    );
                  })}
              </>
            ) : (
              <>
                {/* {identification &&
                  _.map(identification, i => {
                    return draftEntryUiHelper.getIdentificationViewCard(
                      i,
                      false
                    );
                  })} */}

                {signature &&
                  _.map(signature, s => {
                    return draftEntryUiHelper.getSignatureViewCards(
                      'Signer Signature',
                      s.imgData.data
                    );
                  })}

                {witness &&
                  _.map(witness, (wit, index) => {
                    //logger.log('Prining', wit);
                    return (
                      <WitnessRow
                        key={_.uniqueId('witness-row')}
                        signer={data}
                        witness={wit}
                        index={index}
                        isLast={index === witness.length - 1}
                      />
                    );
                  })}
              </>
            )}
          </Row>
        </div>
      </Card>
    ) : (
      <></>
    );
  };

  /**
   * @param start - false: reset to page 0; true: legacy "load more" → next page; omit: refresh current page
   */
  const loadMasterSiners = (start = false, keyword, sortByParam, sortOrder) => {
    const kw =
      keyword !== undefined && keyword !== null ? keyword : searchKeyword;
    const sb =
      sortByParam !== undefined && sortByParam !== null ? sortByParam : sortBy;
    const asc =
      sortOrder !== undefined && sortOrder !== null ? sortOrder : isAsc;

    if (start === false) {
      setPageIndex(0);
    }
    if (start === true) {
      setPageIndex(prev => prev + 1);
    }
    // RTK Query will refetch automatically as state changes.
    if (kw !== searchKeyword) setSearchKeyword(kw);
    if (sb !== sortBy) setSortBy(sb);
    if (asc !== isAsc) setIsAsc(asc);
  };

  useEffect(() => {
    if (signerLoadError) {
      logger.log('error loading Master signer list', signerError);
    }
  }, [signerLoadError, signerError]);

  useEffect(() => {
    dispatch(actionReset());
  }, []);

  useEffect(() => {
    setPageIndex(0);
    // Intentionally load when page size changes only; RTK Query refetches automatically.
  }, [pageSize]);

  // Search Master Client
  const searchItems = useAsyncDebounce(e => {
    let keyword = e.target.value.toLowerCase().trim();
    setSearchKeyword(keyword);
    loadMasterSiners(false, keyword, sortBy, isAsc);
  }, 500);

  // Sort Master Client
  const sortItems = (sortValue, isAsc) => {
    setSortBy(sortValue);
    setIsAsc(isAsc);
    loadMasterSiners(false, searchKeyword, sortValue, isAsc);
  };

  // view each master client record
  const onRowClicked = entry => {
    dispatch(
      showMasterSignerDialog(entry.GUID, 'master', res => {
        if (res) {
          // initializeEntries();
        }
      })
    );
  };

  const handleEditSigner = entry => {
    api.masterSigner.getByGUID(entry.GUID, true).then(res => {
      let singerData = [res].map(item => {
        let data = { ...item, Blob: item?.Blob?.Data || '' };
        data.signerIdentifications = item.Identifications.filter(
          item => !item.IsDeleted
        ).map(item => {
          item.identification_id = idGenerator.getIdentificationId();
          let data = {
            prefix: item?.Prefix,
            id_first_name: item?.FirstName,
            id_middle_name: item?.MiddleName,
            id_last_name: item?.LastName,
            suffix: item?.Suffix,
            id_address_1: item?.Address1,
            id_address_2: item?.Address2,
            id_city: item?.City,
            id_state: item?.State,
            id_postal_code: item?.PostalCode,
            id_type: item?.IdType,
            id_number: item?.IdNumber,
            id_issued_date: item?.IdIssued,
            id_expiration_date: item?.IdExpiration,
            date_of_birth: item?.DateOfBirth,
            notes: item?.AdditionalData,
            id_type_other: item?.IdTypeOther,
            GUID: item?.GUID,
            identification_id: idGenerator.getSignerId(),
            isDeleted: item?.IsDeleted
          };
          return { identification: data };
        });
        data.signer_first_name = item.FirstName;
        data.signer_last_name = item.LastName;
        data.signer_middle_name = item.MiddleName;
        data.IsFavorite = item.IsFavorite;
        data.signer_prefix = item.Prefix;
        data.signer_suffix = item.Suffix;
        data.telephone = item.Telephone;
        data.emailAddress = item.EmailAddress;
        data.id_address_1 = item.Address1;
        data.id_address_2 = item.Address2;
        data.id_city = item.City;
        data.id_state = item.State;
        data.id_postal_code = item.PostalCode;
        data.additionalData = item.AdditionalData;
        data.blob = item.Blob;
        return { ...data };
      });
      setSignerData(signerData => ({
        ...singerData[0],
        // sorted_witness_ids: [],
        isEditMode: true,
        witnessChoice: enums.UI_FLOW_TYPE.SIGNER,
        validationErr: []
      }));
      openSignerForm(true);
    });
  };

  const handleDeleteSigner = entry => {
    setIsSignerDelete(true);
    setSelectedDeletingSigner(entry);
  };

  const handleDuplicateClients = entry => {
    setShowDuplicateModal(true);
    setSelectedDuplicateRecords(entry);
  };

  const confirmDelete = () => {
    const auditLog = {
      audit_log_item_id: idGenerator.getAuditLogItemId(),
      description: `Client ${selectedDeletingSigner?.FirstName} ${selectedDeletingSigner?.LastName} deleted.`,
      timestamp: moment().utc().format()
    };
    const reqData = {
      Blobs: [
        {
          Name: 'AuditLog',
          Description: `AuditLog`,
          ContentType: enums.CONTENT_TYPES.APPLICATION_JSON,
          Data: utils.encodeObjectForBlobData(auditLog)
        }
      ]
    };
    api.masterSigner
      .remove(selectedDeletingSigner?.GUID, reqData)
      .then(() => {
        setIsSignerDelete(false);
        setIsSignerDelete(!issignerDelete);
        setSelectedDeletingSigner(null);
        refetchMasterSigners();
        segmentHelper.track(segmentHelper.events.MASTER_CLIENT_DELETE);
      })
      .catch(error => {
        logger.error('Error deleting master client', error);
      });
  };

  const cancelDelete = () => {
    if (selectedDeletingSigner?.SigningCount > 0) {
      segmentHelper.track(
        `${segmentHelper.events.MASTER_CLIENT_DELETION_WITH_JOURNAL_ENTRY} ${selectedDeletingSigner?.SigningCount}`
      );
    }
    setIsSignerDelete(!issignerDelete);
  };

  const MakeSignerFavorite = e => {
    let data = _.cloneDeep(e);
    data.IsFavorite = !e.IsFavorite;
    setToggleFavorite(e.GUID);
    const auditLog = {
      audit_log_item_id: idGenerator.getAuditLogItemId(),
      description: `Client ${e?.FirstName} ${e?.LastName} ${
        data.IsFavorite ? 'marked as Colleague' : 'removed from Colleagues'
      }.`,
      timestamp: moment().utc().format()
    };
    const reqData = {
      IsFavorite: data.IsFavorite,
      Blobs: [
        {
          Name: 'AuditLog',
          Description: `AuditLog`,
          ContentType: enums.CONTENT_TYPES.APPLICATION_JSON,
          Data: utils.encodeObjectForBlobData(auditLog)
        }
      ]
    };
    api.masterSigner.makeFavorite(e.GUID, reqData).then(res => {
      setToggleFavorite(false);
      segmentHelper.track(
        data.IsFavorite
          ? segmentHelper.events.MASTER_CLIENT_ADDED_COLLEAGUE
          : segmentHelper.events.MASTER_CLIENT_REMOVED_COLLEAGUE
      );
      // Update the master client list
      refetchMasterSigners();
    });
  };

  const renderIdentificationsTag = e => {
    if (e?.IdentificationTypes?.length == 0) {
      return 'NA';
    }
    return (
      <>
        {e.IdentificationTypes.map((item, index) =>
          item !== enums.ID_TYPES.NONE ? (
            <span
              key={index}
              className="ms-2 fs--2 badge badge-soft-success rounded-pill"
            >
              {item}
            </span>
          ) : null
        )}
      </>
    );
  };

  const handleCheckboxChange = (e, record) => {
    if (e.target.checked) {
      setSelectedRecords(prevState => [...prevState, record]);
    } else {
      setSelectedRecords(prevState =>
        prevState.filter(item => item.GUID !== record.GUID)
      );
    }
  };

  const IconAlertCode = function IconAlertDemo({ variant, message }) {
    if (show) {
      return (
        <IconAlert variant={variant} dismissible onClose={() => setShow(false)}>
          <p className="mb-0">{message}</p>
        </IconAlert>
      );
    }
  };

  useEffect(() => {
    refetchMasterSigners();
  }, []);

  return (
    <>
      {/* <PageHeader
        preTitle="Master Client"
        title=" Master Client List"
        description=""
        className="mb-3"
        titleTag="h2"
        image={corner3}
      /> */}

      <IconAlertCode
        variant="info"
        message="Your master client list keeps track of every signer, document witness & credible witness you've entered in to your Notary eJournal. This list is updated every time a new person is added to a journal entry. You can also choose to mark anyone as a colleague. A colleague is a client you're marking as a favorite. These are people you notarize often, and want to easily add to new journal entries. You can filter your client list by who you've marked as a colleague, making it easy to add colleagues to new entries on step 2."
      />

      <div>
        <div>
          <Offcanvas
            id="offcanvas-notarySigner-form"
            show={collapsed}
            backdrop="static"
            onHide={() => {
              setCollapsed(!collapsed);
              resetSignerState();
              setAddressValue();
              setToggleFavorite(false);
              setIsSignerChanged(false);
            }}
            placement="end"
            className="offcanvas-half-width"
          >
            <Offcanvas.Header closeButton>
              <Offcanvas.Title>
                {signerData.isEditMode
                  ? 'Edit Master client'
                  : 'Add Master client'}
              </Offcanvas.Title>
            </Offcanvas.Header>
            <hr className="my-0" />
            <Offcanvas.Body>
              <div>
                <h5 className="text-center">Add Clients & Witnesses</h5>
                <p className="text-center fs-0">
                  Select which method is being used to identify the client. The
                  most common method of identifying the client is by using the
                  client's approved form of paper identification (i.e. drivers
                  license or passport)
                </p>
                <hr className="mb-0" />
                <NotarySignerForm
                  isFrom="master"
                  isMasterSigner={true}
                  signers={signers}
                  signerData={signerData}
                  setSignerData={setSignerData}
                  witnesses={witnesses}
                  identifications={identifications}
                  signatures={signatures}
                  setCollapsed={setCollapsed}
                  openSignerIdentityForm={openSignerIdentityForm}
                  openWitnessAddressForm={openWitnessAddressForm}
                  openWitnessIdentityForm={openWitnessIdentityForm}
                  resetSignerState={resetSignerState}
                  isDocumentWitness={isDocumentWitness}
                  setIsDocumentWitness={setIsDocumentWitness}
                  setAddressValue={setAddressValue}
                  loadMasterSiners={loadMasterSiners}
                  setShowIdentityForm={setShowIdentityForm}
                  setSelectedIdentification={setSelectedIdentification}
                  setIsColleagues={setToggleFavorite}
                  isSignerChanged={isSignerChanged}
                  setIsSignerChanged={setIsSignerChanged}
                />
                {/* <div className="border-dashed border-bottom my-3" /> */}
              </div>
            </Offcanvas.Body>
          </Offcanvas>
        </div>

        {signers && signers.length > 0 ? (
          <Card className="mt-2">
            <FalconCardHeader
              title={
                'Signer' + (signers.length > 1 ? 's' : '') + ' in this entry'
              }
              icon={faUserTie}
              endEl={
                !collapsed ? (
                  <Button size="sm" onClick={() => openSignerForm(null)}>
                    <FontAwesomeIcon icon={faPlusCircle} /> Add another signer
                  </Button>
                ) : (
                  <></>
                )
              }
            />
            <hr className="my-0" />
            <Card.Body>
              {signers.map((s, index) => (
                <SignerRow
                  data={s}
                  key={s.signer_id}
                  isLast={index === signers.length - 1}
                />
              ))}
            </Card.Body>
          </Card>
        ) : (
          <></>
        )}

        {/* {!collapsed && !signers?.length ? <AddNewBlock /> : <></>} */}
      </div>

      <Row className="mb-3 g-3">
        <Col lg={12}>
          <FalconComponentCard noGuttersBottom>
            <FalconComponentCard.Header
              image={corner3}
              className={'px-4'}
              title="Master Client"
              subtitle="Manage your master client list"
              endEl={
                <Flex className={'g-2'}>
                  <div>
                    <Form as={Row} className="gx-2 d-flex align-items-center">
                      <Col xs="auto">
                        <FormLabel className="mb-0">Sort by:</FormLabel>
                      </Col>
                      <Col xs="auto">
                        <InputGroup>
                          <Form.Select
                            size="sm"
                            className="pe-5"
                            defaultValue="Created"
                            onChange={({ target }) =>
                              sortItems(target.value, isAsc)
                            }
                          >
                            <option value="Created">Created</option>
                            <option value="IsFavorite">Colleagues</option>
                            <option value="FirstName">Client Name</option>
                            <option value="JournalEntries">
                              Journal Entries
                            </option>
                            <option value="PotentialDuplicates">
                              Potential Duplicates
                            </option>
                            {/* <option value="lastSeen">Last Seen</option> */}
                          </Form.Select>
                          <InputGroup.Text
                            as={Button}
                            variant="link"
                            className="border border-300 text-700"
                            onClick={() => sortItems(sortBy, !isAsc)}
                          >
                            <FontAwesomeIcon
                              icon={
                                isAsc ? 'sort-amount-up' : 'sort-amount-down'
                              }
                            />
                          </InputGroup.Text>
                        </InputGroup>
                      </Col>
                    </Form>
                  </div>
                  <div className="mx-1">
                    <Form.Control
                      onChange={e => searchItems(e)}
                      placeholder="Search Client List"
                      name="search"
                    ></Form.Control>
                  </div>
                  {selectedRecords.length > 0 && (
                    <div className="mx-1">
                      <Button
                        variant="primary"
                        onClick={() => setShowModal(true)}
                      >
                        <FontAwesomeIcon icon={faLayerGroup} size="sm" /> Merge
                        Clients
                      </Button>
                    </div>
                  )}
                  <div className="mx-1">
                    <Button
                      variant="primary"
                      onClick={() => openSignerForm(null)}
                    >
                      <FontAwesomeIcon icon={faPlusCircle} size="sm" /> New
                      Client
                    </Button>
                  </div>
                </Flex>
              }
            />
            {/* table display */}
            <FalconComponentCard.Body noLight className="py-0 px-4">
              {isLoading && (
                <Flex justifyContent="center" className="py-3">
                  <Spinner size="sm" />
                </Flex>
              )}
              {signerObjects.length > 0 && !isLoading && (
                <Pagination
                  pageIndex={pageIndex}
                  pageSize={pageSize}
                  totalRecords={totalRecords}
                  currentCount={signerObjects.length}
                  onPageChange={setPageIndex}
                  onPageSizeChange={setPageSize}
                  endOfResults={endOfResults}
                  disabled={loading}
                  onRefresh={() => refetchMasterSigners()}
                  loading={loading}
                />
              )}
              {signerObjects.length !== 0 && !signerLoadError && !isLoading && (
                <SimpleBarReact>
                  <Table
                    striped
                    bordered
                    className={loading ? 'refreshing-skeleton' : undefined}
                  >
                    <colgroup>
                      <col />
                      <col />
                      <col className="d-sm-none d-md-block" />
                      <col />
                    </colgroup>
                    <thead>
                      <tr>
                        <th className="" scope="col"></th>
                        <th className="text-center" scope="col">
                          Colleagues
                        </th>
                        <th scope="col">Client Name</th>
                        <th scope="col">Total Identifications </th>
                        <th scope="col">ID Types </th>
                        <th scope="col">Journals entries</th>
                        <th scope="col">Potential Duplicates</th>
                        <th scope="col">Created</th>
                        <th scope="col">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {signerObjects.map(e => {
                        let createdDate = draftEntryUiHelper
                          .getDateTimeWithTimeZone(e.Created)
                          .format('l, LT z');
                        return (
                          <tr key={e.id}>
                            <td className="text-start">
                              <Form.Check
                                type="checkbox"
                                checked={selectedRecords.some(
                                  record => record.GUID === e.GUID
                                )}
                                onChange={event =>
                                  handleCheckboxChange(event, e)
                                }
                              />
                            </td>
                            <td className="text-center cursor-pointer">
                              {toggleFavorite === e.GUID ? (
                                <Spinner size="sm" />
                              ) : (
                                <FontAwesomeIcon
                                  className={e.IsFavorite ? 'text-primary' : ''}
                                  icon={e.IsFavorite ? faStar : faStarRegular}
                                  onClick={() => MakeSignerFavorite(e)}
                                />
                              )}
                            </td>
                            <td
                              className="fw-bold cursor-pointer"
                              onClick={() => onRowClicked(e)}
                            >
                              {e.Prefix && e.Prefix + ' '}
                              {e.FirstName}{' '}
                              {e.MiddleName && ' ' + e.MiddleName + ' '}{' '}
                              {e.LastName} {e.Suffix && ' ' + e.Suffix}
                            </td>
                            <td>{e.IdentificationCount}</td>
                            <td>{renderIdentificationsTag(e)}</td>
                            <td>{e.SigningCount || 0}</td>
                            <td className="d-flex justify-content-center align-items-center">
                              <Button
                                size="sm"
                                title="Verify Duplicates"
                                label="Verify Duplicates"
                                onClick={() => handleDuplicateClients(e)}
                              >
                                Verify ({e.PotentialDuplicateSignerCount || 0})
                              </Button>
                            </td>
                            <td>{createdDate}</td>
                            <td className="cursor-pointer d-flex gap-2">
                              <Button
                                variant="outline-dark"
                                size="sm"
                                title="View"
                                label="View"
                                onClick={() => onRowClicked(e)}
                              >
                                {' '}
                                <FontAwesomeIcon icon={faEye} />
                              </Button>
                              <Button
                                variant="outline-primary"
                                size="sm"
                                title="Edit"
                                label="Edit"
                                onClick={() => handleEditSigner(e)}
                              >
                                {' '}
                                <FontAwesomeIcon icon={faEdit} />
                              </Button>
                              <Button
                                variant="outline-danger"
                                size="sm"
                                title="Delete"
                                label="Delete"
                                onClick={() => handleDeleteSigner(e)}
                              >
                                {' '}
                                <FontAwesomeIcon icon={faTrashAlt} />
                              </Button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </SimpleBarReact>
              )}
              {signerObjects.length === 0 && !loading && (
                <p className="my-3 text-center">You have no client data.</p>
              )}
            </FalconComponentCard.Body>
          </FalconComponentCard>
        </Col>
      </Row>

      <Offcanvas
        id="offcanvas-identity-form"
        show={showIdentityForm}
        backdrop="static"
        onHide={() => {
          setShowIdentityForm(false);
          setSelectedIdentification({});
        }}
        placement="end"
        className="offcanvas-half-width"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Identification Information</Offcanvas.Title>
        </Offcanvas.Header>
        <hr className="my-0" />
        <Offcanvas.Body>
          <IdentificationForm
            signerData={witnessId === null ? signerData : {}}
            witnessId={witnessId}
            setIdentityItem={setIdentityItem}
            setShowIdentityForm={setShowIdentityForm}
            SelectedIdentification={SelectedIdentification}
            setSelectedIdentification={setSelectedIdentification}
            isFrom="master"
            setIsSignerChanged={setIsSignerChanged}
          />
        </Offcanvas.Body>
      </Offcanvas>

      <Offcanvas
        id="offcanvas-address-form"
        show={showAddressForm}
        backdrop="static"
        onHide={() => setShowAddressForm(false)}
        placement="end"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Address form</Offcanvas.Title>
        </Offcanvas.Header>
        <hr className="my-0" />
        <Offcanvas.Body>
          <GenericAddressForm
            setAddressValue={setAddressValue}
            setShowAddressForm={setShowAddressForm}
            addressValue={addressValue}
            register={() => {}}
            errors={{}}
            col={12}
          />
        </Offcanvas.Body>
      </Offcanvas>
      <MergedRecord
        showModal={showModal}
        setShowModal={setShowModal}
        selectedRecords={selectedRecords}
        setSelectedRecords={setSelectedRecords}
        loadMasterSiners={loadMasterSiners}
      />
      <DuplicateRecord
        showDuplicateModal={showDuplicateModal}
        setShowDuplicateModal={setShowDuplicateModal}
        selectedDuplicateRecords={selectedDuplicateRecords}
        setSelectedDuplicateRecords={setSelectedDuplicateRecords}
        loadMasterSiners={loadMasterSiners}
      />
      <Modal
        show={issignerDelete}
        onHide={cancelDelete}
        className="full-screen-modal"
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {selectedDeletingSigner?.SigningCount === 0
              ? 'Confirm Permanent Deletion'
              : 'Unable to delete this client'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedDeletingSigner?.SigningCount === 0
            ? 'Are you sure you wish to permanently delete this Master Client record? This action cannot be undone, and the record will be lost permanently. Please verify that this record is no longer needed before confirming.'
            : 'This client can not be deleted because they are associated with existing journal entries.'}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={cancelDelete}>
            Cancel
          </Button>
          {selectedDeletingSigner?.SigningCount === 0 && (
            <Button variant="primary" onClick={() => confirmDelete()}>
              Confirm
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default MasterSigner;
